import { TOLGEE_GLOBALS } from 'utils'

export const PAGINATION_LIMIT = 8

export const SORT_ORDER = {
  name: 'asc',
  updated_at: 'desc',
}

export const SORT_BY_OPTIONS = [
  {
    key: 'updatedAt',
    value: 'updatedAt',
    label: 'Last edited',
    tolgee: TOLGEE_GLOBALS.lastEdited,
  },
  {
    key: 'name',
    value: 'name',
    label: 'A-Z',
    tolgee: null,
  },
]

export const SORT_BY_TYPE = [
  {
    key: 'select',
    value: null,
    label: 'Select',
    tolgee: TOLGEE_GLOBALS.select,
  },
  {
    key: 'briefing',
    value: 'briefing',
    label: 'Briefing',
    tolgee: TOLGEE_GLOBALS.briefing,
  },
  {
    key: 'dashboard',
    value: 'dashboard',
    label: 'Dashboard',
    tolgee: TOLGEE_GLOBALS.dashboard,
  },
]

export const GET_JOB_ERROR_LOG = {
  from: 'src/modules/dashboard/dashboard-list',
  name: 'Get Jobs with Folders',
  message: 'Fetch list of all dashboards in a workspace with their folders',
}
